import { commonTypes } from '../common';

export const types = {
  SET_SHOW_INSTALLATION_STEP: 'UINEEDS/SET_SHOW_INSTALLATION_STEP',
};

export const initialState = {
  installationAddress: {
    fullAddress: null,
  },
  showInstallationStep: false,
};

const UINeedsInstallationReducer = (state, action) => {
  switch (action.type) {
    case types.SET_SHOW_INSTALLATION_STEP: {
      const { showInstallationStep } = action.payload;
      const newState = {
        ...state,
        showInstallationStep,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case commonTypes.SET_INSTALLATION_ADDRESS: {
      const { installationAddress } = action.payload;

      if (installationAddress.locationId) {
        const newState = {
          ...state,
          installationAddress: {
            ...state.installationAddress,
            id: installationAddress.locationId,
            fullAddress: installationAddress.fullAddress,
          },
        };

        return {
          state: newState,
          stepsMustBeEvaluated: false,
        };
      }

      return null;
    }
    case commonTypes.SET_INSTALLATION_ADDRESS_NAME: {
      const { address } = action.payload;

      const newState = {
        ...state,
        installationAddress: {
          ...state.installationAddress,
          fullAddress: address,
        },
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setShowInstallationStep: value => ({
    type: types.SET_SHOW_INSTALLATION_STEP,
    payload: {
      showInstallationStep: value,
    },
  }),
};

export default UINeedsInstallationReducer;
